<template lang="pug">
img.thumb(ref='image', :title="fixedTitle")
</template>
<script>
import $ from 'jquery'
import _ from 'lodash'

export default {
  props: {
    src: {
      required: true
    },
    title: {
      default: ''
    },
    lazyLoadContainer: {
      default: '#body'
    }
  },
  data () {
    return {
      fixedTitle: this.title
    }
  },
  components: {},
  created () {},
  mounted () {
    if (!this.$refs.image) {
      return
    }
    this.fixedTitle = this.title
    let $image = $(this.$refs.image)
    $image.on('error', () => {
      $image.off('error') // avoid cycle if static/notFound.jpg is not found
      $image.attr('data-srcError', $image.attr('src'))
      $image.attr('src', 'static/notFound.jpg')
      if (this.fixedTitle !== '') {
        this.fixedTitle += ' - '
      }
      this.fixedTitle += 'Image non trouvée'
    })
    if (this.lazyLoadContainer) {
      $image.attr('src', 'static/logo.png')
      let scrollHandler = _.debounce(() => {
        if (this.isElementInViewport()) {
          $image.attr('src', this.src)
          $(this.lazyLoadContainer).off('scroll', scrollHandler)
        }
      }, 400)
      if (this.isElementInViewport()) {
        $image.attr('src', this.src)
      } else {
        $(this.lazyLoadContainer).on('scroll', scrollHandler)
      }
    } else {
      $image.attr('src', this.src)
    }
  },
  destroyed () {},
  computed: {},
  methods: {
    isElementInViewport (el) {
      let rect = this.$el.getBoundingClientRect()
      let t = 100
      return (
        rect.top >= 0 - t && rect.left >= 0 - t && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + t && rect.right <= (window.innerWidth || document.documentElement.clientWidth) + t)
    }
  },
  filters: {},
  watch: {}
}
</script>



// WEBPACK FOOTER //
// ImageThumb.vue?5d219e84